import {MainMenu} from "./MainMenu.js";

export class Menu {
    menuBurgerClass = 'header-menu__burger';

    constructor(domElm) {
        this.domElm = domElm;
        new MainMenu(domElm.querySelector(".main-menu > .nav-menu > .menu"));
        this.menuBurger = document.querySelector(`.${this.menuBurgerClass}`);
        this.addScrollListener();
        this.addListeners();
    }
    addListeners() {
        // Burger menu
        this.menuBurger.addEventListener("click", () => {
            this.domElm.classList.toggle("open");
        })
    }

    addScrollListener() {
        window.addEventListener("scroll", () => this.handleScroll());
        this.handleScroll();
    }

    handleScroll() {
        // Vérifiez si la position de défilement est plus grande que 100 pixels
        const scrollPercentage = Math.max(0, Math.min(1, window.scrollY / 100));

        // Toggle
        if (scrollPercentage === 1) {
            this.domElm.classList.add("scrolled");
            this.domElm.style.setProperty("--percentage-scrolled", scrollPercentage);
        } else {
            this.domElm.classList.remove("scrolled");
            this.domElm.style.setProperty("--percentage-scrolled", 0);
        }
    }
}
